import { Outlet } from 'react-router-dom'
import { MobileNavigation, MobileBottomNavigation } from '@/components/navigation/MobileNavigation'
import { DesktopSidebar } from '@/components/navigation/DesktopSidebar'

export function DashboardLayout() {
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      {/* Mobile Navigation */}
      <MobileNavigation />
      
      {/* Desktop Sidebar */}
      <DesktopSidebar />
      
      {/* Main Content */}
      <div className="lg:pl-64 pb-16 lg:pb-0">
        <main className="py-4 px-4 sm:px-6 lg:px-8">
          <Outlet />
        </main>
      </div>
      
      {/* Mobile Bottom Navigation */}
      <MobileBottomNavigation />
    </div>
  )
}